import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { Brain, MessageSquare, Database, CreditCard } from 'lucide-react';
export function SolutionSection() {
  const features = [{
    icon: <MessageSquare className="w-6 h-6 text-[#00ff41]" data-id="element-219" />,
    title: 'Entiende el Lunfardo',
    desc: 'Habla como un humano, no como un robot frío. Interpreta audios y modismos argentinos.'
  }, {
    icon: <Database className="w-6 h-6 text-[#00ff41]" data-id="element-220" />,
    title: 'Conoce tu Stock',
    desc: 'Se aprende tu catálogo de memoria y sabe exactamente qué ofrecer y qué no.'
  }, {
    icon: <Brain className="w-6 h-6 text-[#00ff41]" data-id="element-221" />,
    title: 'Paciencia Infinita',
    desc: 'Responde la misma pregunta 1000 veces sin cansarse, a las 3 AM o un domingo.'
  }, {
    icon: <CreditCard className="w-6 h-6 text-[#00ff41]" data-id="element-222" />,
    title: 'Cierra Ventas',
    desc: 'Manda links de Mercado Pago o datos de transferencia automáticamente.'
  }];
  return <section className="py-14 px-4 relative overflow-hidden" data-id="element-223">
      <div className="absolute top-1/2 right-0 w-[600px] h-[600px] bg-[#25D366]/5 rounded-full blur-[100px] -z-10" data-id="element-224" />

      <div className="max-w-5xl mx-auto" data-id="element-225">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10" data-id="element-226">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-[#25D366]/10 border border-[#25D366]/30 mb-6 shadow-[0_0_30px_rgba(37,211,102,0.2)]" data-id="element-227">
            <Brain className="w-8 h-8 text-[#25D366]" data-id="element-228" />
          </div>
          <h2 className="text-3xl md:text-5xl font-black text-white mb-6" data-id="element-229">
            Existe una "tercera vía" que las grandes empresas ya usan.
          </h2>
          <p className="text-xl text-[#00ff41] font-medium mb-8" data-id="element-230">
            Y no, no necesitás programadores de Silicon Valley.
          </p>
          <p className="text-lg text-gray-300 max-w-3xl mx-auto leading-relaxed" data-id="element-231">
            Hoy, podés conectar un{' '}
            <strong className="text-white" data-id="element-232">
              Cerebro de Inteligencia Artificial
            </strong>{' '}
            a tu número de WhatsApp actual. Lo llamamos el Método del Vendedor
            de Hierro.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-233">
          {features.map((feature, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: index % 2 === 0 ? -20 : 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="flex gap-4 p-6 bg-[#111] rounded-2xl border border-white/5 hover:border-[#25D366]/30 transition-all hover:bg-[#161616]" data-id="element-234">
              <div className="flex-shrink-0 mt-1" data-id="element-235">
                <div className="w-12 h-12 rounded-xl bg-[#25D366]/10 flex items-center justify-center border border-[#25D366]/20" data-id="element-236">
                  {feature.icon}
                </div>
              </div>
              <div data-id="element-237">
                <h3 className="text-xl font-bold text-white mb-2" data-id="element-238">
                  {feature.title}
                </h3>
                <p className="text-gray-400" data-id="element-239">{feature.desc}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}